export const ACCOUNTING_INTEGRATIONS_DESCRIPTION_COPY =
  "Map your expense categories to their relevant accounts in your accounting software.";
